module.exports = __webpack_public_path__ + "static/media/background.5c66ce06.png";